import React, { ComponentProps } from 'react'
import classnames from 'classnames'
import { FieldProps, Field } from '../Field/Field'
import { Icon } from '@atoms'

export type TextFieldProps = FieldProps & {
    onKeyDown?: (ev: React.KeyboardEvent<HTMLInputElement>) => void
    iconName?: ComponentProps<typeof Icon>['name']
}

const TextField = React.forwardRef<HTMLInputElement, TextFieldProps>(
    (props, ref) => {
        const {
            disabled,
            placeholder,
            value,
            onBlur,
            onChange,
            name,
            type,
            onKeyDown,
            iconName,
        } = props

        const className = classnames(
            'peer w-full bg-transparent border-neutral-300 outline-0 bg-white/0 placeholder:text-placeholder placeholder:text-sm placeholder:font-normal text-inherit'
        )

        const iconClassName = classnames(
            'peer-placeholder-shown:text-placeholder',
            'text-regular',
            'peer-disabled:text-disabled'
        )

        return (
            <Field {...props}>
                <input
                    name={name}
                    ref={ref}
                    placeholder={placeholder}
                    className={className}
                    type={type}
                    disabled={disabled}
                    value={value}
                    onKeyDown={onKeyDown}
                    onChange={(event) => onChange?.(event.target.value)}
                    onBlur={onBlur}
                    data-testid={name}
                />
                {iconName && (
                    <Icon
                        className={iconClassName}
                        name={iconName}
                        size="small"
                    />
                )}
            </Field>
        )
    }
)

TextField.displayName = 'TextField'

export { TextField }
